import { useState } from "react";
import { Link, useOutletContext } from "react-router-dom";
import { requestPasswordReset } from "../../api/clientPortalPublic";
import { formatApiError } from "../../utils/formatApiError";

export default function PortalForgotPassword() {
  const { salonId } = useOutletContext();
  const [identifier, setIdentifier] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");
    setSubmitting(true);
    try {
      await requestPasswordReset(salonId, identifier.trim());
    } catch (err) {
      if (process.env.NODE_ENV !== "production") {
        console.error("Password reset request error:", err);
      }
      setError(formatApiError(err));
    } finally {
      setSubmitting(false);
      setSubmitted(true);
    }
  };

  return (
    <div className="max-w-2xl">
      <div className="rounded-2xl border border-slate-200 bg-white p-6">
        <div className="space-y-2">
          <h2 className="text-xl md:text-2xl font-semibold text-slate-900">
            Forgot your password?
          </h2>
          <p className="text-sm md:text-base text-slate-600">
            Enter your email or username and we will send a reset link.
          </p>
        </div>

        {submitted && (
          <div className="mt-4 rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-sm text-slate-700">
            If an account matches, we emailed a reset link.
          </div>
        )}

        {error && (
          <div className="mt-4 rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-sm text-rose-700">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="mt-6 space-y-4">
          <div className="space-y-2">
            <label className="text-sm font-semibold text-slate-600">
              Email or Username
            </label>
            <input
              type="text"
              value={identifier}
              onChange={(event) => setIdentifier(event.target.value)}
              className="h-11 w-full rounded-xl border border-slate-300 px-4"
              required
            />
          </div>

          <div className="flex items-center gap-3">
            <button
              type="submit"
              disabled={submitting}
              className="rounded-full bg-slate-900 px-5 py-2 text-sm md:text-base font-semibold text-white hover:bg-slate-800 disabled:opacity-60"
            >
              {submitting ? "Sending..." : "Send reset link"}
            </button>
            <Link
              to={`/portal/salon/${salonId}/login`}
              className="rounded-full border border-slate-300 px-5 py-2 text-sm md:text-base font-semibold text-slate-700 hover:bg-slate-50"
            >
              Back to login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
